exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  background-color: rgba(0, 0, 0, 0.6); }\n  :host .container {\n    padding: 40px;\n    border-radius: 2px;\n    background-color: #ffffff;\n    box-shadow: 0 7px 24px 0 rgba(0, 0, 0, 0.8);\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-flow: column;\n        flex-flow: column; }\n    :host .container img {\n      width: 70px; }\n    :host .container span {\n      text-align: center;\n      font-size: 22px;\n      font-weight: bold;\n      margin-top: 20px;\n      white-space: nowrap; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/betting/success/success.component.scss
// module id = ../../../../../src/app/betting/success/success.component.scss
// module chunks = 1